import { createSelector } from 'reselect';

export const getMultiSampleState = (state) => state.cards.cardCatalog.multiSampleState;

export const getMultiSampleLimit = createSelector(
  getMultiSampleState,
  (multiSampleState) => multiSampleState.count.limit
);
